"use client";

import { Zap, TrendingUp } from "lucide-react";
import type { NewsFilterType } from "@/vybe-trader-client/news/newsView";

interface NewsFilterChipsProps {
  value: NewsFilterType;
  onChange: (value: NewsFilterType) => void;
}

interface Chip {
  id: NewsFilterType;
  label: string;
  icon?: React.ElementType;
  /** Breaking gets the destructive role when active (matches the mock). */
  danger?: boolean;
}

const CHIPS: Chip[] = [
  { id: "all", label: "All" },
  { id: "breaking", label: "Breaking", icon: Zap, danger: true },
  { id: "market_moving", label: "Market moving", icon: TrendingUp },
];

/**
 * Sticky one-tap filter rail (proposal 65) — replaces the dropdown-menu filter
 * that used to hide All / Breaking / Market-moving behind an extra tap. Bound to
 * the same `NewsFilterType` state the feed already filters on.
 */
export default function NewsFilterChips({ value, onChange }: NewsFilterChipsProps) {
  return (
    <div className="flex shrink-0 items-center gap-1.5 overflow-x-auto px-3 pb-2">
      {CHIPS.map((chip) => {
        const active = value === chip.id;
        const Icon = chip.icon;
        const base =
          "flex shrink-0 items-center gap-1 rounded-full border px-3 py-1 font-mono text-[10px] transition-colors";
        const state = active
          ? chip.danger
            ? "border-red-600 bg-red-600 text-white"
            : "border-blue-400 bg-blue-400 text-background"
          : "border-border bg-muted/30 text-muted-foreground";
        return (
          <button
            key={chip.id}
            type="button"
            onClick={() => onChange(chip.id)}
            aria-pressed={active}
            className={`${base} ${state}`}
          >
            {Icon && <Icon className="h-2.5 w-2.5" />}
            {chip.label}
          </button>
        );
      })}
    </div>
  );
}
